var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 15,
    fill: "#3BE2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.611 17a5.834 5.834 0 0 0-3.731 1.987 4.894 4.894 0 0 0-1.023 1.775 4.817 4.817 0 0 0-.2 2.029 4.934 4.934 0 0 0 2.095-.496 4.822 4.822 0 0 0 1.668-1.336 5.24 5.24 0 0 0 1.008-1.861c.204-.68.267-1.394.183-2.098Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.801 25.072a6.318 6.318 0 0 0-2.105-1.735 6.466 6.466 0 0 0-2.658-.702c-2.208 0-3.176 1.024-4.669 1.024-1.492 0-2.779-1.024-4.764-1.024a6.455 6.455 0 0 0-2.873.893 6.281 6.281 0 0 0-2.128 2.088c-1.779 2.7-1.477 7.762 1.413 12.093 1.032 1.552 2.413 3.275 4.208 3.29 1.794.016 2.048-1.008 4.223-1.008 2.176 0 2.589 1.024 4.193 1.009 1.603-.016 3.255-1.94 4.271-3.493a16.595 16.595 0 0 0 1.588-2.903 5.416 5.416 0 0 1-2.371-1.797 5.21 5.21 0 0 1-.412-5.625 5.366 5.366 0 0 1 2.084-2.11Z",
    fill: "#fff"
  })));
};
export default SvgApple;